import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import { TabListProps } from "@/types";
import { useVModel } from "@/hooks";
import { Separator } from "@/components";


/**
 * Renders content across multiple tabs.
 */
const __default__ = {
  name: "TabList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    tabs: {},
    vertical: { type: Boolean },
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;



const model = useVModel(props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_tabs, {
      modelValue: _unref(model),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
      "active-color": "primary",
      align: "left",
      breakpoint: 0,
      vertical: props.vertical,
      class: _normalizeClass(props.class)
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "before"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, ({ id, name }) => {
          return (_openBlock(), _createBlock(_component_q_tab, {
            key: id,
            name: id,
            label: name,
            "no-caps": ""
          }, null, 8, ["name", "label"]))
        }), 128)),
        _renderSlot(_ctx.$slots, "after")
      ]),
      _: 3
    }, 8, ["modelValue", "vertical", "class"]),
    (props.vertical)
      ? (_openBlock(), _createBlock(_unref(Separator), {
          key: 0,
          vertical: "",
          class: "q-mr-md"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_q_tab_panels, {
      modelValue: _unref(model),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
      animated: "",
      class: "bg-transparent full-width",
      vertical: props.vertical,
      "transition-prev": props.vertical ? 'jump-up' : undefined,
      "transition-next": props.vertical ? 'jump-down' : undefined
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, ({ id }) => {
          return (_openBlock(), _createBlock(_component_q_tab_panel, {
            key: id,
            name: id,
            class: "q-pt-sm q-px-none"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, id)
            ]),
            _: 2
          }, 1032, ["name"]))
        }), 128))
      ]),
      _: 3
    }, 8, ["modelValue", "vertical", "transition-prev", "transition-next"])
  ], 64))
}
}

})